import React, { useEffect, useState } from "react";
// import './DesktopClientInstallModal.css';
import Modal from 'react-modal';
import RegionIcon from './images/region_icon.png';
import FFIcon from './images/ff-icon.png';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";

const DesktopClientInstallModal = ({accessToken, showDesktopClientInstallModal, setShowDesktopClientInstallModal, callback, deeplink}) => {
    const [regions, setRegions] = useState([]);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    useEffect(() => {
        async function fetchData() {
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                const response = await API.getAvailableServers(accessToken);
                if (response.status !== 200) {
                    console.log("Error getting available servers.");
                    return;
                }

                const data = await response.json();
                setRegions(data.servers);
            }
        }
        fetchData();
    }, [isAuthenticated, getAccessTokenSilently]);
    async function enterWorld() {
        window.location.href = deeplink
        setShowDesktopClientInstallModal(false);
        callback();
    }
    return (
        <Modal
            isOpen={showDesktopClientInstallModal}
            parentSelector={()=> document.querySelector('.enter-world-container')}
            className="RegionSelectionModal__Content ff-modal-content ff-center"
            overlayClassName="RegionSelectionModal__Overlay"
            onRequestClose={() => setShowDesktopClientInstallModal(false)}
            shouldCloseOnOverlayClick={false}>
            <img style={{objectFit: "contain"}} src={FFIcon} alt="Future Fest Icon" />
            <h2 className="connect-wallet-title">Update Future Fest Launcher</h2>
            <div style={{textAlign: 'center'}}>After installation, click Enter World below to join the action!</div>
            <button className="ff-button" onClick={enterWorld}>Enter World</button>
            <hr width="100%" />
            <p style={{fontSize: "smaller"}} className="connect-wallet-subtitle">Launcher didn't download?</p>
            <span style={{fontSize: "smaller"}}><a href="https://ff-desktop-clients.s3.amazonaws.com/FutureFestLauncherSetup.exe">Download Installer</a> or <a href="https://www.futurefest.io/support" target="_blank" rel="noopener noreferrer">Click here for help</a></span>
        </Modal>
    );
};

export default DesktopClientInstallModal;
